import { useRef, useState } from 'react';
import { KeyRound } from 'lucide-react';
import { toast } from 'sonner';
import { Dialog, DialogHeader, DialogTitle, DialogDescription } from '../../components/ui/dialog';
import { CRMDialogContent } from './CRMDialogContent';
import { Button } from '../../components/ui/button';
import { StaffPasswordField } from './StaffPasswordField';
import { apiError, crmAPI } from '../context/CRMAuthContext';

export const StaffPasswordReset = ({ staff, version, onClose, onSaved }) => {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const inFlight = useRef(false);
  const save = async event => {
    event.preventDefault();
    event.stopPropagation(); // Dialog portals still bubble React events to the staff form.
    if (inFlight.current || !confirm) return;
    setError('');
    if (password.length < 12 || new TextEncoder().encode(password).length > 72 || !/[a-z]/.test(password) || !/[A-Z]/.test(password) || !/[0-9]/.test(password)) {
      setError('Şifre en az 12 karakter, büyük/küçük harf ve rakam içermeli; 72 baytı aşmamalıdır.'); return;
    }
    inFlight.current = true; setBusy(true);
    try {
      const { data } = await crmAPI.put(`/users/${staff.id}/password`, { new_password: password, expected_version: version });
      setPassword('');
      toast.success('Şifre yenilendi. Personelin önceki oturumları sonlandırıldı.');
      onSaved(data);
    } catch (e) { setError(e.response ? apiError(e) : 'Şifre değişikliği doğrulanamadı. Güncel kaydı kontrol edin.'); }
    finally { inFlight.current = false; setBusy(false); }
  };
  return <Dialog open onOpenChange={open => { if (!open && !inFlight.current) onClose(); }}>
    <CRMDialogContent className="crm-dialog crm-staff-password-reset" data-testid="crm-staff-password-reset-dialog" onPointerDownOutside={e => { if (busy) e.preventDefault(); }} onEscapeKeyDown={e => { if (busy) e.preventDefault(); }}>
      <DialogHeader><DialogTitle>Personel Şifresini Yenile</DialogTitle><DialogDescription data-testid="crm-staff-password-reset-target">{staff.first_name} {staff.last_name} · {staff.email}</DialogDescription></DialogHeader>
      <form onSubmit={save} data-testid="crm-staff-password-reset-form">
        <StaffPasswordField value={password} onChange={setPassword} busy={busy}/>
        <label className="crm-staff-password-confirm" htmlFor="staff-password-reset-confirm"><input id="staff-password-reset-confirm" data-testid="crm-staff-password-reset-confirm" type="checkbox" checked={confirm} disabled={busy} onChange={e => setConfirm(e.target.checked)}/><span>Şifrenin değişmesini ve mevcut oturumların sonlandırılmasını onaylıyorum.</span></label>
        {error && <p role="alert" className="crm-error" data-testid="crm-staff-password-reset-error">{error}</p>}
        <div className="crm-dialog-actions"><Button type="button" variant="outline" disabled={busy} data-testid="crm-staff-password-reset-cancel" onClick={onClose}>Vazgeç</Button><Button type="submit" className="crm-primary" disabled={busy || !confirm || !password} data-testid="crm-staff-password-reset-submit"><KeyRound size={16}/>{busy ? 'Yenileniyor…' : 'Şifreyi Yenile'}</Button></div>
      </form>
    </CRMDialogContent>
  </Dialog>;
};